<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-4"
          fab
          text
          right
          color="error"
          v-on="on"
          v-bind="attrs"
          @click="showDialog = true"
        >
          <eva-icon fill="red" name="trash-2-outline"></eva-icon>
        </v-btn>
      </template>
      <span>{{ $t("dss.deleteMedication") }}</span>
    </v-tooltip>
    <v-dialog
      width="600px"
      v-model="showDialog"
    >
      <div class="dashboard-dialog-window">
        <div class="dashboard-dialog-window__message">
          {{ $ucfirst($t('questionnaire_mm.sure_to_delete', {catalog: 'app_tablet', params: {drugName: medicationName} })) }}
        </div>
        <div class="dashboard-dialog-window__actions">
          <v-btn
            x-large
            text
            class="ml-4"
            @click="remove"
          >
            {{ $ucfirst($t('confirm')) }}
          </v-btn>
          <v-btn
            x-large
            text
            class="ml-4"
            @click="showDialog = false"
            color="primary"
          >
            {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
/**
 * Component MedicationRemoveButton.vue
 *
 * @module MedicationRemoveButton
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/Medication/MedicationRemoveButton.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MedicationRemoveButton',
  props: {
    medicationId: {
      type: String,
      required: true,
    },
    medicationName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showDialog: false,
    }
  },
  methods: {
    remove() {
      this.$emit('remove');
      this.showDialog = false;
    }
  },
};
</script>
